import * as React from "react";
import LegalPage from "../components/legal/LegalPage";
import { privacyPolicy } from "../data/legal";
import { ROUTE_LINKS } from "../utils/routes";

const PrivacyPolicyPage: React.FC = () => {
  return <LegalPage path={ROUTE_LINKS.privacyPolicy} document={privacyPolicy} />;
};

export default React.memo(PrivacyPolicyPage);
